<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'gridimgnotitle',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="[30,30]">
        <a-col  :sm="getCol.sm(data.col)" :md="getCol.md(data.col)"  :lg="getCol.lg(data.col)"  v-for="(item,i) in data.child" :key="i">
            <a class="content-box box-shadow" style="padding:0;" :href="item.url" >
              <img :src="addip(item.pic)" :alt="item.name" style="width: 100%;height:auto;" />
            </a>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="gridimgnotitle">
import {defineComponent,defineProps } from 'vue'
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
</script>
